import { render } from "./BoqReviewBreakdown.vue?vue&type=template&id=7f3457f2"
import script from "./BoqReviewBreakdown.vue?vue&type=script&lang=js"
export * from "./BoqReviewBreakdown.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__